var _arity = require('./_arity');
var _curry2 = require('./_curry2');


module.exports = function _createPartialApplicator(concat) {
  return _curry2(function(fn, args) {
    return _arity(Math.max(0, fn.length - args.length), function() {
      return fn.apply(this, concat(args, arguments));
    });
  });
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramda/src/internal/_createPartialApplicator.js
 ** module id = 1454
 ** module chunks = 0
 **/